let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c8Q5z")).then(() => parcelRequire('6mvQ1'));